/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputWindLabPoint
 */
export interface InputWindLabPoint {
    /**
     * 
     * @type {number}
     * @memberof InputWindLabPoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof InputWindLabPoint
     */
    lng?: number;
}

/**
 * Check if a given object implements the InputWindLabPoint interface.
 */
export function instanceOfInputWindLabPoint(value: object): boolean {
    return true;
}

export function InputWindLabPointFromJSON(json: any): InputWindLabPoint {
    return InputWindLabPointFromJSONTyped(json, false);
}

export function InputWindLabPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputWindLabPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
    };
}

export function InputWindLabPointToJSON(value?: InputWindLabPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

